
import { message } from "antd";
import FetchData from '@ezviz/FetchData';
import { getEVentList } from './eventConfig';
import intl from 'react-intl-universal';
import { Route, useParams } from "react-router-dom";

message.config({
  top: 300,
  maxCount: 3
});

// 更新事件配置
export const UPDATE_EVENTCONFIG_DETAIL = "UPDATE_EVENTCONFIG_DETAIL";


// 新增事件配置
export function addEventConfig(params) {
  return (dispatch, getState) => {
    const data = {
      //产品ID
      productId: params.productId,
      //领域ID
      dId: params.dId,
      //事件key
      eKey: params.eKey,
      //消息分类
      eCategory: "",
      //事件名称
      eName: "",
      //是否提醒用户 不提醒：NO 提醒：YES
      eNotice: "YES",
      //消息类型 信息类：text 视频类：video
      eMsgType: "text",
      //客户端入口 告警：alarm 通知：notice
      eClientEntrance: "alarm",
      //消息Code
      eCode: "",
      //事件推送文案
      ePush: "",
      //事件推送文案(中文)
      ePushCh: "",
      //事件推送文案(英文)
      ePushEn: "",
      //消息列表文案
      eList: "",
      //消息列表文案(中文)
      eListCh: "",
      //消息列表文案(英文)
      eListEn: "",
      //消息详情文案
      eDetail: "",
      //消息详情文案(中文)
      eDetailCh: "",
      //消息详情文案(英文)
      eDetailEn: "", 
      //RN/H5链接(推送)
      eRhPush: "",
      //RN/H5链接(消息列表)
      eRhList: "",
      //默认图片
      ePicurl: "",
      //上报频率控制
      eReportInterval: 1,
      //存储生命周期
      eStorageCycle: 7,
      //推送间隔
      ePushInterval: 1
    }
    dispatch(updateEventConfigData(data));
  }
}

// 编辑已有的事件配置
export function editEventConfig(value) {
  return (dispatch, getState) => {
    const newEPush = {zh:value.ePushCh,en:value.ePushEn};
    const newEList = {zh:value.eListCh,en:value.eListEn};
    const newEDetail = {zh:value.eDetailCh,en:value.eDetailEn};
    const data = {
        //产品ID
        productId: value.productId,
        //领域ID
        dId: value.dId,
        //事件key
        eKey: value.eKey,
        //消息分类
        eCategory: value.eCategory,
        //事件名称
        eName: value.eName,
        //是否提醒用户 不提醒：NO 提醒：YES
        eNotice: value.eNotice,
        //消息类型 信息类：text 视频类：video
        eMsgType: value.eMsgType,
        //客户端入口 告警：alarm 通知：notice
        eClientEntrance: value.eClientEntrance,
        //消息Code
        eCode: value.eCode,
        //事件推送文案
        ePush: JSON.stringify(newEPush),
        //事件推送文案(中文)
        ePushCh: value.ePushCh,
        //事件推送文案(英文)
        ePushEn: value.ePushEn,
        //消息列表文案
        eList: JSON.stringify(newEList),
        //消息列表文案
        eListCh: value.eListCh,
        //消息列表文案
        eListEn: value.eListEn,
        //消息详情文案
        eDetail: JSON.stringify(newEDetail),
        //消息详情文案(中文)
        eDetailCh: value.eDetailCh,
        //消息详情文案(英文)
        eDetailEn: value.eDetailEn,
        //RN/H5链接(推送)
        eRhPush: value.eRhPush,
        //RN/H5链接(消息列表)
        eRhList: value.eRhList,
        //默认图片
        ePicurl: value.ePicurl,
        //上报频率控制
        eReportInterval: 1,
        //存储生命周期
        eStorageCycle: value.eStorageCycle,
        //推送间隔
        ePushInterval: 1
    }

    dispatch(updateEventConfigData(data));
    }
}

// 更新事件配置
export function updateEventConfigData(data) {
    return (dispatch, getState) => {
        const { eventConfigDetail,hasData } = getState().eventConfigEdit;
        const newData = Object.assign({}, eventConfigDetail, data);
        dispatch({
        type: UPDATE_EVENTCONFIG_DETAIL,
        eventConfigDetail: newData,
        hasData
        });
    };
}

// 保存事件配置
export function saveEventConfigData(params,callback) {
    return (dispatch, getState) => {
        const { productDetail } = getState().product;
        const { hasData } = getState().eventConfigEdit;
        const url = '/iot/config/api/iot/support/event/msg';
        const newEPush = {zh:params.ePushCh,en:params.ePushEn};
        const newEList = {zh:params.eListCh,en:params.eListEn};
        const newEDetail = {zh:params.eDetailCh,en:params.eDetailEn};
        const body = {
        //产品ID
        productId: productDetail.productId,
        //领域ID
        dId: params.dId,
        //事件key
        eKey: params.eKey,
        //消息分类
        eCategory: params.eCategory,
        //事件名称
        eName: params.eName,
        //是否提醒用户 不提醒：NO 提醒：YES
        eNotice: params.eNotice,
        //消息类型 信息类：text 视频类：video
        eMsgType: params.eMsgType,
        //客户端入口 告警：alarm 通知：notice
        eClientEntrance: params.eClientEntrance,
        //消息Code
        eCode: params.eCode,
        //事件推送文案
        ePush: JSON.stringify(newEPush),
        //事件推送文案(中文)
        ePushCh: params.ePushCh,
        //事件推送文案(英文)
        ePushEn: params.ePushEn,
        //消息列表文案
        eList: JSON.stringify(newEList),
        //消息列表文案
        eListCh: params.eListCh,
        //消息列表文案
        eListEn: params.eListEn,
        //消息详情文案
        eDetail: JSON.stringify(newEDetail),
        //消息详情文案(中文)
        eDetailCh: params.eDetailCh,
        //消息详情文案(英文)
        eDetailEn: params.eDetailEn,
        //RN/H5链接(推送)
        eRhPush: params.eRhPush,
        //RN/H5链接(消息列表)
        eRhList: params.eRhList,
        //默认图片
        ePicurl: params.ePicurl,
        //上报频率控制
        eReportInterval: 1,
        //存储生命周期
        eStorageCycle: params.eStorageCycle,
        //推送间隔
        ePushInterval: 1
      };
      let status;
      if(hasData == "no"){
        status = true;
      }else{
        // if(params.isAdd === "add"){
        //   status = true
        // }else if(params.isAdd === "edit"){
          status = false
        // }
      }
      const fetchData = new FetchData(url, {
        method: status?"POST":"PUT",
        body,
        metaHandler: {
          403: () => { window.location.href = '/authrization/login'; return; }
        },
      });
      fetchData
        .then(data => {
          if (data.code == '200') {
            dispatch(getEVentList({pid:params.productId}))
            message.success(intl.get('commmon.operate.success'));
            callback&&callback();
          } else {
            message.error(data.msg || intl.get('commmon.operate.retry'));
          }
        })
        .catch(e => {
          message.error(intl.get('commmon.operate.retry'));
        });
    };
}
  
  